import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { ID } from '@/types/model'
import { getChargeSchedules, setChargeScheduleError } from '@/actions/schedule'
import { PayloadAction } from '@reduxjs/toolkit'
import { VehicleChargerChargeSchedule } from '@/types'

export default function useVehicleChargerScheduleFetcher(vehicleChargerId: ID) {
  const dispatch = useAppDispatch()
  const chargeScheduleExists = useAppSelector((state) => {
    const schedule = state.schedule.chargeSchedules?.find(
      (schedule) => schedule.charger_id === vehicleChargerId,
    )
    return Boolean(schedule)
  })
  const canFetchSchedules = useAppSelector((state) => {
    const { isLoading, errors } = state.schedule
    return !isLoading && !Object.keys(errors).length
  })

  const schedule = useAppSelector((state) => {
    return state.schedule.chargeSchedules?.find(
      (schedule) => schedule.charger_id === vehicleChargerId,
    )
  })

  const chargeScheduleIsLoadingOrIdle = useAppSelector((state) => {
    const isLoading = state.schedule.isLoading
    return isLoading || !schedule
  })

  useEffect(
    function fetchChargeScheduleWhenNeeded() {
      if (chargeScheduleExists) {
        return
      }
      if (canFetchSchedules) {
        dispatch(getChargeSchedules()).then(
          (response: PayloadAction<VehicleChargerChargeSchedule[]>) => {
            const scheduleInPayload = response?.payload?.find(
              (schedule) => schedule.charger_id === vehicleChargerId,
            )
            if (!scheduleInPayload) {
              // As a fallback, we set an error if the charger isn't found
              dispatch(
                setChargeScheduleError(
                  // @ts-expect-error createAction used in js file
                  `Vehicle charger ${vehicleChargerId} not found`,
                ),
              )
            }
          },
        )
      }
    },
    [chargeScheduleExists],
  )

  return {
    data: schedule,
    isLoadingOrIdle: chargeScheduleIsLoadingOrIdle,
  }
}
